import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { openPrivacy } from "@/lib/site";

const KEY = "yu-cookie-ok";

export default function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(KEY, "1");
    } catch {}
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-notice"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-5 left-5 z-[60] max-w-sm border border-[#383029] bg-[#16110E] p-5 shadow-[0_12px_30px_rgba(0,0,0,0.5)]"
        >
          <p className="text-xs leading-relaxed text-[#C4BBB0] sm:text-sm">
            Questo sito usa solo strumenti tecnici necessari a funzionare. Niente cookie di profilazione, niente pubblicità. Dettagli nell'{" "}
            <button
              data-testid="cookie-privacy-link"
              onClick={openPrivacy}
              className="underline decoration-[#383029] underline-offset-2 transition-colors duration-300 hover:text-[#E05A2C]"
            >
              informativa privacy
            </button>
            .
          </p>
          <button
            data-testid="cookie-accept-button"
            onClick={accept}
            className="mt-4 min-h-[44px] rounded-full bg-[#E05A2C] px-6 py-2.5 text-sm font-medium text-white transition-colors duration-300 hover:bg-[#F26B3A] active:scale-[0.98]"
          >
            Ho capito
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
